import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.alabaster,
  h1Color: colors.equineIron,
  h2Color: colors.equineIron,
  paraColor: colors.equineStone,
  anchorColor: colors.equineStone
};
export default richText;